// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"28fe7a56","94":"1ee3edac","120":"e1b0e5fe","126":"53023049","171":"7116a3a8","407":"4a1c020f","432":"68694bcd","532":"7475aa73","674":"6a7754e9","684":"51160265","711":"1a2f6e43","744":"a01d31a7","994":"8974723b"}[chunkId] + ".chunk.js";
};